export const currencyTRY = (n) =>
  new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);

export const numberTR = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(
    Number(n) || 0,
  );

export const dateTR = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d)) return iso;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
};

export const dateInputValue = (iso) => {
  if (!iso) return "";
  return iso.slice(0, 10);
};

export const today = () => new Date().toISOString().slice(0, 10);

export const daysBetween = (a, b) => {
  if (!a || !b) return 0;
  const da = new Date(a);
  const db = new Date(b);
  return Math.max(Math.round((db - da) / 86400000), 0);
};

export const daysSince = (a) => {
  if (!a) return 0;
  return daysBetween(a, new Date().toISOString());
};
